<template lang="html">
  <!-- Sidebar -->
  <!-- <div class="border-right" id="sidebar-wrapper">
    <div class="header-sidebar" slot="header">
      <img
        :src="basepath + '/unodc_logo.png'"
        alt="UNODC"
        style="width:200px"
      />
    </div>
    <div class="list-group list-group-flush">
      <router-link
        to="/dashboard/Trainee/traineeDashboard"
        class="list-group-item list-group-item-action"
      >
        <i class="material-icons">home</i> Dashboard
      </router-link>
      <div>
        <div
          slot="header"
          class="list-group-item list-group-item-action"
          id="mybutton"
        >
          <i class="material-icons pr-1">brightness_low</i
          ><b>Training Management</b>
        </div>

        <ul>
          <router-link
            to="/dashboard/Trainee/addReference"
            class="list-group-item list-group-item-action"
          >
            <i class="material-icons">remove</i> Add Reference
          </router-link>

          <router-link
            to="/dashboard/Trainee/knowledgeBaseRepository"
            class="list-group-item list-group-item-action"
          >
            <i class="material-icons">remove</i> Knowledge Base
          </router-link>
        </ul>
      </div>
      <div>
        <div
          slot="header"
          class="list-group-item list-group-item-action"
          id="mybutton"
        >
          <i class="material-icons pr-1">settings</i><b>Settings</b>
        </div>

        <ul>
          <router-link
            to="/dashboard/Trainee/TraineeReg"
            class="list-group-item list-group-item-action"
          >
            <i class="material-icons">remove</i> Profile Settings
          </router-link>
        </ul>
      </div>
    </div>
  </div> -->
  <!-- Sidebar -->

  <div class="border-right" id="sidebar-wrapper">
            <div class="header-sidebar" slot="header">
                <img :src="basepath+'/unodc_logo.png'" alt="UNODC" style="width:200px" />
                </div>
                <div class="list-group list-group-flush"><span>
                <router-link to= "/dashboard/Trainee/traineeDashboard" class="list-group-item list-group-item-action">
                <i class="material-icons" >home</i>Home
                </router-link>
                </span>
                
                <router-link to="/dashboard/Trainee/addReference"  class="list-group-item list-group-item-action">
                <i class="material-icons">supervisor_account</i> Add Reference
                </router-link>
                <router-link to="/dashboard/Trainee/knowledgeBaseRepository"  class="list-group-item list-group-item-action">
                <i class="material-icons">file_copy</i> Knowledge Base
                </router-link>

                <router-link to="/dashboard/Trainee/TraineeReg" class="list-group-item list-group-item-action">
                <i class="material-icons">ballot</i> Profile Settings
                </router-link>

                </div>
                </div>
</template>

<script>
//import { bus } from "../../../main";
export default {
  data: () => ({
    show: false,
    // activeTab: 'Tab2',
    active: true,
    basepath: localStorage.getItem("BASE_PATH"),
    userId: JSON.parse(localStorage.getItem("currentUser")),
    trainingId: "",
    profileSettings: true,
    addReference: false,

    gallery: false
  }),
  mounted() {},
  created() {},
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    showTab() {
      this.show = true;
    }
  }
};
</script>
<style>
/* .list-group-item:hover {
  padding-left: 30px;
  transition: 0.5s ease;
  color: #06a6e0;
} */
</style>

<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.6;
}
/*!
                * Start Bootstrap - Simple Sidebar (https://startbootstrap.com/template-overviews/simple-sidebar)
                * Copyright 2013-2019 Start Bootstrap
                * Licensed under MIT (https://github.com/BlackrockDigital/startbootstrap-simple-sidebar/blob/master/LICENSE)
                */

body {
  overflow-x: hidden;
}
@media (min-width: 768px) {
  .sidebarx {
    display: block !important;
  }
  .vs-sidebar--background {
    z-index: 0 !important;
    background: transparent !important;
  }
}

@media (max-width: 768px) {
  .vs-sidebar--background {
    background: rgba(0, 0, 0, 0.2) !important;
  }
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}
#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
/* scrollbar css starts */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(7, 167, 225);
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(7, 167, 225);
}
/* scrollbar css ends */
</style>
